module.exports = __webpack_public_path__ + "img/moon.20d32f1b.svg";